<template>
  <div class="mbBox">
    <BrowserWarning v-if="showModel" v-model="showModel" />
    <div class="mbHeader">
      <div class="logo"></div>
       <div class="download" @click="goToRecharge">
            在线充值
      </div>
      <div class="download" id="downLoadApp">下载APP</div>
    </div>
    <div class="mbMain">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div>
            <p class="desc-Fm7x">附近推荐</p>
            <p class="title-2wvz">高颜值</p>
          </div>
          <div class="imgWrap img0"></div>
        </div>
        <div class="swiper-slide">
          <div>
            <p class="desc-Fm7x">聊天消息</p>
            <p class="title-2wvz">回复超快</p>
          </div>
          <div class="imgWrap img1"></div>
        </div>
        <div class="swiper-slide">
          <div>
            <p class="desc-Fm7x">真人认证</p>
            <p class="title-2wvz">超真实</p>
          </div>
          <div class="imgWrap img2"></div>
        </div>
      </div>
    </div>
    <div class="mbFooter">
      <p class="copyright">桔子州网络版权所有  @深圳桔子州网络科技有限公司</p>
    </div>
  </div>
</template>

<script src="https://sdk.openinstall.io/openinstall.js"></script>

<script>
import { isWeChatBrowser, isIOS } from "./../utils/device";
import BrowserWarning from "./../components/BrowserWarning.vue"
export default {
  name: "MobileInviteView",
  data() {
    return {
      isWeChatBrowser: isWeChatBrowser(),
      showModel: isWeChatBrowser(),
    };
  },
  components: {
    BrowserWarning
  },
  mounted:function(){
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = '//web.cdn.openinstall.io/openinstall.js';
            s.addEventListener('load',()=>{
              var data = OpenInstall.parseUrlParams();
              new OpenInstall({
                  appKey : "vqjcj0",   //appkey参数配置,需要自行替换对应的appkey
                  onready : function() {
                      var m = this, button = document.getElementById("downLoadApp");
                      m.schemeWakeup();  //尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
                      button.onclick = function() {
                          m.wakeupOrInstall(); //此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
                          return false;
                      }
                  }
              }, data);
            },false);
            document.head.appendChild(s);
       },
  methods: {
    // 在线充值
    goToRecharge() {
      window.open('https://call.mihuachat.com/wap/index.html', '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.mbBox {
  width: 100vw;
  height: 100vh;
  background-color: #ff367d;
  .mbHeader {
    background: hsla(0, 0%, 100%, 0.15);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99;
    height: 17.6vw;
    // background: #ff367d;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    max-width: 640px;
    .logo {
      margin-left: 4.266667vw;
      width: 42.666667vw;
      height: 7.466667vw;
      background: url(./../assets/title0.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .recharge-button {
        background: linear-gradient(90deg, #FF6B35 0%, #F7931E 100%);
        border-radius: 20px;
        padding: 8px 20px;
        color: white;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        box-shadow: 0 4px 8px rgba(247, 147, 30, 0.3);
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(247, 147, 30, 0.4);
        }
    }
    .download {
      margin-right: 3.733333vw;
      height: 10.666667vw;
      line-height: 10.666667vw;
      width: 21.333333vw;
      background: #fff;
      border-radius: 5.333333vw;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ff367d;
      letter-spacing: 0;
    }
  }
  .mbMain {
    padding-top: 26vw;
    perspective: 1200px;
    min-height: 500px;
    background-color: #ff367d;
    .swiper-slide {
      transform-style: preserve-3d;
      .desc-Fm7x {
        font-size: 14px;
        color: #fff;
        line-height: 5.333333vw;
        text-align: center;
        margin: 0;
      }
      .title-2wvz {
        font-size: 28px;
        color: #fff;
        text-align: center;
        line-height: 10.666667vw;
        margin-top: 0.8vw;
        margin-bottom: 5.333333vw;
        font-weight: 500;
      }
      .imgWrap {
        display: block;
        width: 72vw;
        height: 145.333333vw;
        margin: 0 auto;
      }
      .imgWrap.img0 {
        //background: 50% / cover no-repeat url(./../assets/img1.png);
        background: 50% / cover no-repeat url(https://photo.mihuachat.com/admin/img1.png);
      }
      .imgWrap.img1 {
        //background: 50% / cover no-repeat url(./../assets/img2.png);
        background: 50% / cover no-repeat url(https://photo.mihuachat.com/admin/img2.png);
      }
      .imgWrap.img2 {
        //background: 50% / cover no-repeat url(./../assets/img3.png);
        background: 50% / cover no-repeat url(https://photo.mihuachat.com/admin/img3.png);
      }
    }
  }
  .mbFooter {
    background-color: #ff367d;
    .copyright {
      opacity: 0.6;
      font-size: 9px;
      color: #fff;
      text-align: center;
      padding-top: 5.866667vw;
      padding-bottom: 3.2vw;
    }
  }
}
</style>
